export default __webpack_public_path__ + "static/media/actify_icon.e3eda667.svg";